import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Box from "@amzn/meridian/esm/components/box";
import Row from "@amzn/meridian/esm/components/row";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import HelpTabInClient from "./helpTab/HelpTabInClient";
import SummariesTabInClient from "./summaryTab/SummariesTabInClient";
import SidebarInClient from "./common/SidebarInClient";

/**
 * MainClientHome Component
 *
 * This component serves as the main entry UI for users in the "MainClient" mode.
 * It features a side menu with two selectable tabs: "Summaries" and "Help".
 *
 * Functionality:
 * - When "Summaries" is selected, it displays the SummariesTabInClient component,
 *   showing the list of meeting summaries or related content.
 * - When "Help" is selected, it renders the HelpTabInClient component,
 *   which includes a FeedbackCard for user feedback and a WikiCard for documentation or assistance.
 *
 * The component uses state to manage the selected tab and dynamically renders
 * the appropriate content based on the user's selection.
 */
const MainClientHome = () => {
  const location = useLocation();
  const initialTab = location.state?.selectedTab || "summaries";
  const [selectedTab, setSelectedTab] = useState(initialTab);
  const returnPage = location.state?.returnPage ?? 1;

  return (
    <Row spacing="none" spacingInset="none" alignmentVertical="top">
      <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
        <Box type="outline" spacing="none" spacingInset="none" minHeight={557} minWidth={176}>
          <SidebarInClient selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        </Box>
      </Theme>

      {selectedTab === "help" && <HelpTabInClient />}
      {selectedTab === "summaries" && (
        <>
          <SummariesTabInClient returnPage={returnPage} />
        </>
      )}
    </Row>
  );
};

export default MainClientHome;
